export const LIST_ROLE = 'LIST_ROLE'
export const LIST_PERMISSION = 'LIST_PERMISSION'
export const DETAIL_ROLE = 'DETAIL_ROLE'
export const TOTAL_ROLE = 'TOTAL_ROLE'
